require('initializers/gettext').default(__TRANSLATIONS__.gettext.fi); // eslint-disable-line no-undef
require('initializers/i18n').default('fi', __TRANSLATIONS__.i18n.fi); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/fi');
require('jquery-ui/ui/i18n/datepicker-fi');
require('moment/locale/fi');
require('dayjs/locale/fi');
